var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1236_2436)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 56,
    height: 56,
    rx: 12,
    fill: "url(#paint0_linear_1236_2436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.25 18.125C29.25 17.5016 28.7484 17 28.125 17C27.5016 17 27 17.5016 27 18.125V20C25.3453 20 24 21.3453 24 23H22.125C21.5016 23 21 23.5016 21 24.125C21 24.7484 21.5016 25.25 22.125 25.25H24V27.875H22.125C21.5016 27.875 21 28.3766 21 29C21 29.6234 21.5016 30.125 22.125 30.125H24V32.75H22.125C21.5016 32.75 21 33.2516 21 33.875C21 34.4984 21.5016 35 22.125 35H24C24 36.6547 25.3453 38 27 38V39.875C27 40.4984 27.5016 41 28.125 41C28.7484 41 29.25 40.4984 29.25 39.875V38H31.875V39.875C31.875 40.4984 32.3766 41 33 41C33.6234 41 34.125 40.4984 34.125 39.875V38H36.75V39.875C36.75 40.4984 37.2516 41 37.875 41C38.4984 41 39 40.4984 39 39.875V38C40.6547 38 42 36.6547 42 35H43.875C44.4984 35 45 34.4984 45 33.875C45 33.2516 44.4984 32.75 43.875 32.75H42V30.125H43.875C44.4984 30.125 45 29.6234 45 29C45 28.3766 44.4984 27.875 43.875 27.875H42V25.25H43.875C44.4984 25.25 45 24.7484 45 24.125C45 23.5016 44.4984 23 43.875 23H42C42 21.3453 40.6547 20 39 20V18.125C39 17.5016 38.4984 17 37.875 17C37.2516 17 36.75 17.5016 36.75 18.125V20H34.125V18.125C34.125 17.5016 33.6234 17 33 17C32.3766 17 31.875 17.5016 31.875 18.125V20H29.25V18.125ZM28.5 23H37.5C38.3297 23 39 23.6703 39 24.5V33.5C39 34.3297 38.3297 35 37.5 35H28.5C27.6703 35 27 34.3297 27 33.5V24.5C27 23.6703 27.6703 23 28.5 23ZM37.5 24.5H28.5V33.5H37.5V24.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1236_2436",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1236_2436"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1236_2436"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1236_2436"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1236_2436",
    result: "effect2_dropShadow_1236_2436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1236_2436",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1236_2436",
    x1: 5,
    y1: 1,
    x2: 61,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0891B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGate);
export default __webpack_public_path__ + "static/media/ic_gate.fbcfa4a25a92d80e3f13029c743cdcd7.svg";
export { ForwardRef as ReactComponent };